import { AsideInterface } from '@stores';
import React from 'react';
import { ChevronRight } from 'react-feather';
import { useTranslation } from 'react-i18next';

type Props = {
  links: AsideInterface[];
  onclick: (title: string) => void;
  current?: string;
};

export const Crumbs = ({ links, onclick, current }: Props) => {
  const { t } = useTranslation();

  const l = Object.keys(links).length;

  return (
    <>
      {l > 1 && (
        <nav className="flex mb-4" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
            {links.map((link, index) => (
              <li key={link.title}>
                <div className="flex items-center">
                  {!!link.parent ? <ChevronRight size={14} /> : ''}

                  <button
                    className={`
    text-sm font-medium hover:text-blue-600 dark:hover:text-white
    ${link.parent ? 'ms-1 md:ms-2' : ''}
    ${link.focused ? 'text-blue-700' : 'text-gray-700 dark:text-gray-400'}
  `}
                    onClick={() => onclick(link.title)}
                  >
                    {t(link.title)}
                  </button>
                </div>
              </li>
            ))}
          </ol>
        </nav>
      )}
    </>
  );
};

export default Crumbs;
